export default __webpack_public_path__ + "static/13-f7ecc747a25e96e8493bc08d1fe9fe2a.jpg";